import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Minus, Circle, Undo2, RotateCcw, Pencil } from 'lucide-react';

export const Controls = ({ onDrawLine, onDrawCircle, onFreeDraw, onUndo, onReset, currentTool }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2 px-3 py-2 bg-card border-b border-border">
      <div className="flex flex-wrap items-center gap-1.5">
        <Button
          onClick={onDrawLine}
          variant={currentTool === 'line' ? 'default' : 'outline'}
          size="sm"
          className="transition-smooth h-8 px-3 text-xs"
        >
          <Minus className="h-3 w-3 mr-1.5" />
          {t('controls.draw_line')}
        </Button>
        
        <Button
          onClick={onDrawCircle}
          variant={currentTool === 'circle' ? 'default' : 'outline'}
          size="sm"
          className="transition-smooth h-8 px-3 text-xs"
        >
          <Circle className="h-3 w-3 mr-1.5" />
          {t('controls.draw_circle')}
        </Button>

        <Button
          onClick={onFreeDraw}
          variant={currentTool === 'freedraw' ? 'default' : 'outline'}
          size="sm"
          className="transition-smooth h-8 px-3 text-xs"
        >
          <Pencil className="h-3 w-3 mr-1.5" />
          Free Draw
        </Button>
        
        <div className="w-px h-6 bg-border mx-1" />
        
        <Button
          onClick={onUndo}
          variant="outline"
          size="sm"
          className="transition-smooth h-8 px-3 text-xs"
        >
          <Undo2 className="h-3 w-3 mr-1.5" />
          {t('controls.undo')}
        </Button>
        
        <Button
          onClick={onReset}
          variant="outline"
          size="sm"
          className="transition-smooth hover:bg-destructive hover:text-destructive-foreground h-8 px-3 text-xs"
        >
          <RotateCcw className="h-3 w-3 mr-1.5" />
          {t('controls.reset')}
        </Button>
      </div>
    </div>
  );
};